import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { OrderRow } from '../../../models/orderRow';
import { Product } from '../../../models';

export interface OrderDeliveryRequest {
  orderId: string;
  rows: OrderDeliveryRequestRow[];
}

export interface OrderDeliveryRequestRow {
  rowId: string;
  deliveryQuantity: number;
}

@Injectable({
  providedIn: 'root'
})
export class ProductionManagementShipOrdersService {
  // Define the API endpoint
  private apiUrl = 'json/production/deliveries';

  constructor(protected http: HttpClient) { }

  // Create a new item
  deliverOrder(item: OrderDeliveryRequest): Observable<any> {
    return this.http.post<OrderDeliveryRequest>(`${this.apiUrl}/deliver-order`, item);
  }

  deliverOrderAndMarkAsFinished(item: OrderDeliveryRequest): Observable<any> {
    return this.http.post<OrderDeliveryRequest>(`${this.apiUrl}/deliver-order-and-finish`, item);
  }

  sendNoStockEmail(row: OrderRow, product: Product): Observable<boolean> {
    return of(false);
  }

  sendLastBoxStockEmail(row: OrderRow, product: Product): Observable<boolean> {
    return of(false);
  }
}
